import React from 'react';
import { Box, IconButton } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faArrowRight } from '@fortawesome/pro-light-svg-icons';
import MssTooltip from '../../common/MssTooltip';

export const CardControls = ({ currentIndex, total, onPrev, onNext }) => (
  <Box id="studyDeck__box_cardControls" className="cardControls">
    {/* Wrapped in a span so the tooltip still fires on hover once the button
        disables at either end of the deck. */}
    <MssTooltip id="studyDeck__tooltip_prevCard" title="Previous card">
      <span>
        <IconButton
          id="studyDeck__iconButton_prevCard"
          className="pagerButton"
          onClick={onPrev}
          disabled={currentIndex === 0}
          aria-label="Previous card"
        >
          <FontAwesomeIcon icon={faArrowLeft} />
        </IconButton>
      </span>
    </MssTooltip>

    <MssTooltip id="studyDeck__tooltip_nextCard" title="Next card">
      <span>
        <IconButton
          id="studyDeck__iconButton_nextCard"
          className="pagerButton"
          onClick={onNext}
          disabled={currentIndex === total - 1}
          aria-label="Next card"
        >
          <FontAwesomeIcon icon={faArrowRight} />
        </IconButton>
      </span>
    </MssTooltip>
  </Box>
);
